
  const jobPosition = document.querySelector('[data-forms-id="forms-root-678695"]');

  if (jobPosition) {
    const dataPositionFormEl = document.querySelector('[data-position_form]');
    let dataPositionForm = '';

    if (dataPositionFormEl) {
      try {
        dataPositionForm = JSON.parse(dataPositionFormEl.textContent);
      } catch (e) {
        console.error('JSON parse error:', e);
      }
    }
      
    function waitForElement(selector, root = document) {
      return new Promise(resolve => {
        const el = root.querySelector(selector);
        if (el) return resolve(el);

        const observer = new MutationObserver(() => {
          const el = root.querySelector(selector);
          if (el) {
            resolve(el);
            observer.disconnect();
          }
        });

        observer.observe(root, { childList: true, subtree: true });
      });
    }

    waitForElement('form-embed#app-embed').then(formEmbed => {
      const shadow = formEmbed.shadowRoot;

      if (shadow) {
        const style = document.createElement('style');
        style.textContent = `
          section._formContainer_1q1d2_30._grid_1q1d2_148._noImage_1q1d2_161 {
            max-width: 990px !important;
            width: 100% !important;
          }

          h2._textHeading_2aowh_35,
          h2._formBannerHeading_z5ku3_9 {
            font: normal 700 32px var(--LAGUNA-FONT) !important;
          } 

          div._textBody_2aowh_10 p {
            font: normal 400 24px var(--GOTHAM-FONT) !important;
          }

          p._textBody_2aowh_10 {
            font: normal 400 16px var(--GOTHAM-FONT) !important;
          }

          label._formInputFieldLabel_1mxsl_38 {
            font: normal 400 16px var(--GOTHAM-FONT) !important;
          }
          
          button._formSubmitButton_cit2d_96 {
            font: normal 400 16px var(--GOTHAM-FONT) !important;
          }

          form._formFieldset_cit2d_82 {
            gap: 20px !important;
          }

          ._formPhoneInputField_1ym3p_17 {
            font: normal 400 16px var(--GOTHAM-FONT) !important;
          }

          ._selectToggle_12thd_25 {
            height: 100% !important;
            max-height: 100% !important;
          }

          .form-info-block {
            font: normal 400 16px var(--GOTHAM-FONT) !important;
            margin-top: 30px;
            width: 100%;
            border-top: 1px solid #20202033;
          }

          .form-info-block a {
            color: black;
            margin: 0 5px;
          }
        `;
        shadow.appendChild(style);

        if (dataPositionForm == '') return;

        waitForElement('input[id="custom#visionary"]', shadow).then(inputEl => {
          const parent =inputEl.closest('._formFieldContainer_1mxsl_5'); 

          const infoDiv = document.createElement('div');
          infoDiv.classList.add('form-info-block')
          infoDiv.innerHTML = dataPositionForm.richtext_for_position_form;

          parent.parentNode.insertBefore(infoDiv, parent);
        });
      }
    });
  }